export const TYPES = {
  GET_OWNER_INFO_SUCCESS: "role/GET_OWNER_INFO_SUCCESS",
  SELECT_IS_OWNER_SUCCESS: "role/SELECT_IS_OWNER_SUCCESS",
};
